<div class="session-item" [class.selected]="isSelected()" [class.context-menu-open]="isOpenContextMenu()">
  @if (isRenameState()) {
    <input-title
      class="session-name"
      [text]="sessionItem()?.name || 'New Chat'"
      [inputModel]="title"
      (onChange)="onChange($event)"
      (onBlurUInput)="updateName()"
      (outsideClick)="updateName()"
    >
    </input-title>
  } @else if (generateName()) {
    <div class="session-name generate-name">{{ generateName() }}</div>
  } @else {
    <div
      class="session-name static"
      #sessionItemTitle
      (mouseenter)="updateTooltip(sessionItemTitle)"
      [tooltipDisabled]="tooltipDisabled()"
      [pTooltip]="displayName()"
      tooltipPosition="right"
      tooltipStyleClass="u-tooltip"
    >
      {{ displayName() }}
    </div>
    <div class="session-action">
      <u-toggle-button
        (onChange)="openContextMenu($event)"
        [checked]="isOpenContextMenu()"
        [onIcon]="'dots-horizontal'"
        [sizeElement]="'small'"
      ></u-toggle-button>
    </div>
  }
</div>
